// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"035c10eb","80":"cc99f665","116":"601b0944","284":"57f216dc","317":"13fce12f","372":"57c6fbad","424":"374ea235","665":"a4eb0724","705":"1bfa0534","802":"238996ab","819":"db1e5a06","858":"f881da00"}[chunkId] + ".chunk.js";
};